<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>教职绩效->流程跟踪</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 列表数据 -->
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.assessNo" placeholder="编号"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.assessUser" placeholder="被考核人"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.processStatus" clearable placeholder="流程状态">
                            <el-option
                                v-for="item in processStatuss"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            &nbsp;
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                <el-button type="primary" @click="exportExcel">导出Excel</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                element-loading-background = "rgba(255, 255,255,0.7)"
                :element-loading-text = "loadingText"
                v-loading="loading" 
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"></el-table-column>
                <el-table-column prop="assessNo" label="编号"  ></el-table-column>
                <el-table-column prop="assessUser" label="被考核人"  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="title" label="考核标题"  :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="startYear" label="开始年份"  width="80px"></el-table-column>
                <el-table-column prop="endYear" label="结束年份"  width="80px"></el-table-column>
                <el-table-column prop="schoolName" label="学校名称"  width="100px"></el-table-column>
                <el-table-column label="流程进度"  width="250px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.processStatus == 1">
                            <div style="font-weight:bold;">流程状态：填报中</div>
                            <div style="font-weight:bold;">内容详情：</div>
                            <div v-html="scope.row.processStatusLabel"></div> 
                            <div style="font-weight:bold;">填报人：{{scope.row.checkUser}}</div>
                        </div>
                        <div v-else-if="scope.row.processStatus == 2">
                            <div style="font-weight:bold;">流程状态：学校审批中</div>
                            <div style="font-weight:bold;">内容详情：</div>
                            <div v-html="scope.row.processStatusLabel"></div>
                            <div style="font-weight:bold;">审核人：{{scope.row.checkUser}}</div>
                        </div>
                        <div v-else-if="scope.row.processStatus == 3">
                            <div style="font-weight:bold;">流程状态：学区审批中</div>
                            <div style="font-weight:bold;">内容详情：</div>
                            <div v-html="scope.row.processStatusLabel"></div>
                            <div style="font-weight:bold;">审核人：{{scope.row.checkUser}}</div>
                        </div>
                        <div v-else-if="scope.row.processStatus == 9">
                            完成
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="selfScore" label="自评总分"  width="80px"></el-table-column>
                <el-table-column prop="schoolScore" label="学校评分"  width="80px"></el-table-column>
                <el-table-column prop="areaScore" label="学区评分"  width="80px"></el-table-column>
                <el-table-column prop="remark" label="审批信息" :show-overflow-tooltip="true" width="150px"></el-table-column>
                <el-table-column prop="gmtCreate" label="生成时间"  width="100px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.processStatus == 9
                            && currUserId != 1 
                            && scope.row.currentOperator.indexOf(currUserId)>-1"
                            @click.native.prevent="back(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">回退到填报</span>
                        </el-button>

                        <el-button 
                            @click.native.prevent="updateAssess(scope.row,4)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">查看</span>
                        </el-button>

                        <el-button v-if="scope.row.processStatus == 9
                            && (scope.row.assessUserId == currUserId || currUserId == 1)"
                            @click.native.prevent="print(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">打印</span>
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 新增弹出框 -->
        <div v-if="assessMainVisible">
            <assessMain ref="assessMain"></assessMain>
        </div>
        <!-- 回退弹出框 -->
        <div v-if="backVisible">
            <back ref="back"></back>
        </div>
        <!-- 打印绩效 -->
        <div v-if="printTeacherAssessVisible">
            <printTeacherAssess ref="printTeacherAssess"></printTeacherAssess>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http'; 
    import assessMain from './AssessMain.vue';
    import back from './Back.vue';
    import printTeacherAssess from './PrintTeacherAssess.vue';

    export default {
        name:"TeacherAssessProcess",
        data(){
            return{
                loading:false,
                loadingText:"",

                assessMainVisible:false,
                backVisible:false,
                printTeacherAssessVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    assessNo:"",
                    assessUser:"",
                    processStatus:""
                },
                data:[],
                processStatuss:[{
                    value: 1,
                    label: '填报中'
                }, {
                    value: 2,
                    label: '学校审批中'
                }, {
                    value: 3,
                    label: '学区审批中'
                }, {
                    value: 9,
                    label: '已完成'
                }],
                currUserId:""
            }
        },
        components: {
            assessMain,back,printTeacherAssess
        },
        created:function () {
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
            // console.log('============'+this.currUserId);
            this.getData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let url  = this.teacherAssessProcessListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    assessNo:this.form.assessNo,
                    assessUser:this.form.assessUser,
                    processStatus:this.form.processStatus
                };

                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res.data));
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //填写，审批，查看
            updateAssess(data,sign){
                this.assessMainVisible=true;
                this.$nextTick(() => {
                    this.$refs['assessMain'].init(data,sign);
                })
            },
            back(data){ // 回退到填报
                this.backVisible=true;
                this.$nextTick(() => {
                    this.$refs['back'].init(data);
                })
            },
            exportExcel(){
                let msg="导出数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.teacherAssessFlowTaskExportExcelUrl;
                console.log("url:"+url);
                let param = new URLSearchParams();
                param.append('assessNo', this.form.assessNo);
                param.append('assessUser', this.form.assessUser);
                param.append('processStatus', this.form.processStatus);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '流程跟踪.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
            },
            print(data){ // 打印绩效
                this.printTeacherAssessVisible=true;
                this.$nextTick(() => {
                    this.$refs['printTeacherAssess'].init(data);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/teacherAssess/TeacherAssessProcess.vue